export const tabs = [
  { id: 'cec', title: 'Comptes et cartes' },
  { id: 'epargne', title: 'Épargner' },
  { id: 'invest', title: 'Investir' },
  { id: 'emprunter', title: 'Emprunter' },
  { id: 'deal', title: 'Bons plans' },
  { id: 'info', title: 'S’informer' },
] as const

export type TabID = (typeof tabs)[number]['id']

export const linksGroup = [
  {
    parent: 'cec',
    id: 'cec_cartes',
    title: 'cartes bancaires',
    links: [
      {
        title: 'Fosfo Mastercard',
        url: '/compte-bancaire/carte-fosfo-mastercard',
      },
      {
        title: 'Gold Mastercard',
        url: '/compte-bancaire/carte-gold-mastercard',
      },
      {
        title: 'World Elite Mastercard',
        url: '/compte-bancaire/carte-world-elite-mastercard',
      },
      {
        title: 'Comparer les cartes',
        url: '/compte-et-cartes',
      },
      {
        title: 'Cartes American Express',
        url: '/compte-bancaire-american-express',
      },
    ],
  },
  {
    parent: 'cec',
    id: 'cec_comptes',
    title: 'comptes',
    links: [
      {
        title: 'Compte individuel',
        url: '/compte-bancaire',
      },
      {
        title: 'Compte joint',
        url: '/compte-bancaire/compte-joint',
      },
    ],
  },
  {
    parent: 'cec',
    id: 'cec_services',
    title: 'services',
    links: [
      {
        title: 'Carte bancaire virtuelle',
        url: '/compte-bancaire/carte-bancaire-virtuelle',
      },
      {
        title: 'Application mobile',
        url: '/application-mobile',
      },
      {
        title: 'Comparateur de frais bancaires',
        url: '/comparateur-frais-bancaires-gratuit/simulation',
      },
      {
        title: 'Mobilité bancaire',
        url: '/compte-bancaire/changement-domiciliation-bancaire',
      },
      {
        title: 'Assurance moyens de paiement',
        url: '/compte-bancaire/assurance-moyens-paiement',
      },
    ],
  },
  {
    parent: 'epargne',
    id: 'epargne_livret',
    title: 'Livrets d’Épargne',
    links: [
      {
        title: 'Livret +',
        url: '/epargne/livret-plus',
      },
      {
        title: 'Livret + enfant',
        url: '/epargne/livret-plus-enfant',
      },
      {
        title: 'Livret A',
        url: '/epargne/livret-a',
      },
      {
        title: 'LDDS',
        url: '/epargne/livret-developpement-durable',
      },
      {
        title: 'Comparer les livrets  d’épargne',
        url: '/epargne',
      },
    ],
  },
  {
    parent: 'epargne',
    id: 'epargne_finance',
    title: 'Épargne financière',
    links: [
      {
        title: 'Assurance-vie',
        url: '/assurance-vie',
      },
      {
        title: 'Plan Épargne Retraite (PER)',
        url: '/per-plan-epargne-retraite',
      },
    ],
  },
  {
    parent: 'epargne',
    id: 'epargne_service',
    title: 'Service',
    links: [
      {
        title: 'Sélection stars',
        url: '/assurance-vie/selection-stars',
      },
    ],
  },
  {
    parent: 'invest',
    id: 'invest_bourse',
    title: 'produits boursiers',
    links: [
      {
        title: 'Découvrir les comptes bourse',
        url: '/bourse',
      },
      {
        title: "Plan d'Épargne en Actions (PEA)",
        url: '/bourse/plan-epargne-actions',
      },
      {
        title: 'PEA-PME',
        url: '/bourse/plan-epargne-actions-pme',
      },
      {
        title: 'Compte-titres',
        url: '/bourse/compte-titres',
      },
      {
        title: 'Nos offres partenaires',
        url: '/bourse/offres-partenaires',
      },
    ],
  },
  {
    parent: 'invest',
    id: 'invest_services',
    title: 'services',
    links: [
      {
        title: 'Cours boursiers',
        url: 'https://bourse.fortuneo.fr/',
      },
      {
        title: 'Plateforme de trading (Live Trader)',
        url: '/bourse/live-trader',
      },
    ],
  },
  {
    parent: 'invest',
    id: 'invest_ressources',
    title: 'ressources',
    links: [
      {
        title: 'Podcast Bourse – Dans la place',
        url: '/podcast-bourse-dans-la-place ',
      },
    ],
  },
  {
    parent: 'emprunter',
    id: 'emprunter_',
    title: 'credits',
    links: [
      {
        title: 'Crédit immobilier',
        url: '/credit-immobilier',
      },
      {
        title: 'Prêt personnel',
        url: '/pret-personnel',
      },
    ],
  },
  {
    parent: 'emprunter',
    id: 'emprunter_assurance',
    title: 'Assurance emprunteur',
    links: [
      {
        title: "Changer d'assurance emprunteur",
        url: '/credit-immobilier/changer-assurance-emprunteur',
      },
    ],
  },
  {
    parent: 'emprunter',
    id: 'emprunter_service',
    title: 'service',
    links: [
      {
        title: 'Simulateur crédit immobilier',
        url: '/credit-immobilier#simulateur-credit',
      },
    ],
  },
  {
    parent: 'deal',
    id: 'deal_index',
    links: [
      {
        title: 'Offre de bienvenue',
        url: '/offres-speciales-fortuneo',
      },
      {
        title: 'Offre de parrainage',
        url: '/parrainage',
      },
      {
        title: 'Offre partenaires bourse',
        url: '/bourse/offres-partenaires',
      },
      {
        title: 'Offre mobilité bancaire',
        url: '/compte-bancaire/changement-domiciliation-bancaire',
      },
    ],
  },
  {
    parent: 'info',
    id: 'info_ressources',
    title: 'ressources',
    links: [
      {
        title: 'Blog',
        url: '/blog',
      },
      {
        title: 'Podcast Bourse – Dans la place',
        url: '/podcast-bourse-dans-la-place',
      },
    ],
  },
]
